import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function OrdersIcon({ width = 24, height = 24, color = 'black' }) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <Path
        d="M9 11H7v8h2v-8zm4-4h-2v12h2V7zm4-4h-2v16h2V3zM5 21v-7H3v9h18v-2H5z"
        fill={color}
      />
    </Svg>
  );
}

export default OrdersIcon;
